
import { Button } from "@portal/BaseComponents/Button/AntButton";
import { ConFirm } from "@portal/BaseComponents/Modal/AntModal";
import { ToolTip } from "@portal/BaseComponents/ToolTip/AntTooltip";
import { Icon } from "@portal/lib/icons/icons";
import { useDeleteDocument } from "@portal/queries/document-query";

const DeleteIcon = (
  <Icon icon={['far','trash-alt']} color="var(--primary-7)" fontSize={14} />
);

interface DeleteDocProps {
  id: string;
}

function Delete(props: DeleteDocProps) {
  const { id } = props;
  const deleteDocument = useDeleteDocument();
  function handleClick() {
    ConFirm({
      title: "Confirm Delete",
      content: "Delete the document permanently?",
      okText: "Yes",
      onOk() {
        deleteDocument.mutateAsync(id);
      },
      centered: true,
      okType: "primary",
      okButtonProps: {
        style: {
          backgroundColor: "var(--primary-7)",
        },
      },
      cancelButtonProps: {
        type: 'text',
        style: {
          color: "var(--primary-7)",
        },
      },
    });
  }

  return (
    <ToolTip title="Delete">
      <Button icon={DeleteIcon} size='middle' onClick={handleClick} />
    </ToolTip>
  );
}

export { Delete };
